<template>
    <div>

        <alert-simple />
        <alert-options />
        <alert-custom :noclose="alert_custom.noclose">
            <template #custom>
                <android v-if="alert_custom.type === 'android'"/>
                <apple v-if="alert_custom.type === 'ios'"/>
            </template>
            <template #message v-if="alert_custom.message !== null">
                <div class="text-center">
                    <p class="h6"> {{ alert_custom.message }} </p>
                </div>
            </template>

            <template #custom-buttons v-if="['logged', 'register'].includes(alert_custom.type)">

                <div class="text-center mt-4" v-if="alert_custom.type == 'logged'">
                    <div class="d-flex justify-content-center">
                        <vs-button
                            flat
                            @click="nextStep()"
                        >
                            {{ $t('button_action.continue') }}
                        </vs-button>
                    </div>
                </div>

                <div class="text-center mt-4" v-if="alert_custom.type == 'register'">

                    <div class="d-flex justify-content-center">
                        <vs-button
                            color="rgb(75,154,43)"
                            flat
                            @click="getRegister"
                        >
                            {{ $t('button_action.register') }}
                        </vs-button>

                        <vs-button
                            flat
                            @click="nextStep()"
                        >
                            {{ $t('button_action.continue_sr') }}
                        </vs-button>
                    </div>
                </div>

                <!-- <div class="text-center mt-4">
                    <div>
                        <mu-button color="red" @click="closeAlert()" class="mr-3">
                            {{ $t('button_action.close') }}
                        </mu-button>

                        <mu-button color="success" @click="nextStep()" class="ml-3">
                            {{ $t('button_action.continue') }}
                        </mu-button>
                    </div>
                    <div class="text-center mt-3">
                        <mu-button flat color="primary" @click="getRegister">
                            {{ $t('button_action.register') }}
                        </mu-button>
                    </div>
				</div> -->
            </template>
        </alert-custom>

        <alert-authenticate @sign-in="signIn" title="traveller.welcome" :loading="loading_authenticate" />

        <Loading />

        <component :is="layout">      
            <router-view tag></router-view>
        </component>

        <!-- <Bottom-Sheet>
            <template #actions>
                <mu-col>
                    <mu-button small flat @click="setCookies(true)">{{ $t('button_action.accept') }}</mu-button>
                </mu-col>
            </template>
        </Bottom-Sheet> -->
    </div>
</template>

<script>
    // HELPERS
    import _GlobalHelper from '@/store/helpers/global'
    import _ReservationHelper from '@/store/helpers/reservation/reservation'
    // COMPONENTS
    import AlertSimple from '@/components/Modal/AlertSimple'
    import AlertOptions from '@/components/Modal/AlertOptions'
    import AlertCustom from '@/components/Modal/AlertCustom'
    import AlertAuthenticate from '@/components/Modal/AlertAuthenticate'
    import Android from '@/components/Device/Android'
    import Apple from '@/components/Device/Apple'
    import Loading from '@/components/Loading/Index'
    import BottomSheet from '@/components/BottomSheet/Index'

    import { mapActions, mapGetters, mapMutations } from 'vuex'

    export default {
        name: 'root',
        data() {
            return {
                loginActive: false,
                loading_authenticate: false
            }
        },
        components: {
            AlertSimple,
            AlertOptions,
            AlertCustom,
            AlertAuthenticate,
            Loading: Loading,
            BottomSheet: BottomSheet,
            Android,
            Apple
        },
        computed: {
            ...mapGetters ({
                reservation: _ReservationHelper.getters.reservation,
                show_search_form: _GlobalHelper.getters.show_search_form,
                alert_custom: _GlobalHelper.getters.alert_custom,
                lang: _GlobalHelper.getters.language
            }),
            layout() {
                return this.$router.resolve({ path: this.$route.path }).route.meta.layout   
            }
        },
		methods: {
            ...mapMutations({
                setAlertSimple: _GlobalHelper.mutations.setAlertSimple,
                setAlertCustom: _GlobalHelper.mutations.setAlertCustom,
                setAuthenticate: _GlobalHelper.mutations.setAuthenticate,
                setCookies: _GlobalHelper.mutations.setAcceptCookies
            }),

            ...mapActions({
                payment: _ReservationHelper.actions.payment
            }),

            getRegister () {
                window.open('https://viajero.vallartaplus.mx/registro', '_blank')
            },

            nextStep() {
                this.setAlertCustom({
					show: false,
					title: null,
					message: null,
                    type: null,
                    method: this.alert_custom.method,
                    continue: true
				})
            },

            closeAlert() {
                this.setAlertCustom({
					show: false,
					title: null,
					message: null,
                    type: null,
                    continue: false
				})
                this.$delete(this.alert_custom, 'method')
            },

            signIn(event) {
                this.loading_authenticate = true

                let message_error = []

                if(!this.$validator.hasValue(event.username)) {
                    message_error.push('traveller.error.auth.username')
                }
                else if(isNaN(event.username) && !this.$validator.isEmail(event.username)) {
                    message_error.push('traveller.error.auth.email')
                }
                else if(!isNaN(event.username) && (event.username.length != 7 && event.username.length != 8 && event.username.length != 10)) {
                    message_error.push('traveller.error.auth.card')
                }

                if(!this.$validator.hasValue(event.password)) {
                    message_error.push('traveller.error.auth.password_empty')
                }

                if(message_error.length > 0) {

                    this.loading_authenticate = false

                    this.setAlertSimple({
                        show: true,
                        title: 'traveller.error.auth.title',
                        message: message_error
                    })

                    return
                }

                setTimeout(() => {
                    this.payment({
                        code: this.reservation.code,
                        method: 'frequent_traveller',
                        device: "web",
                        total: this.reservation.summary.total,
                        card_number: event.username,
                        password: event.password
                    }).then(({ success, data, error }) => {
                        let message = []

                        if(!success) {

                            let message_error = []
                            for(let key in error) {
                                message_error.push(`traveller.error.auth.${error[key].code}`)
                            }

                            this.setAlertSimple({
                                show: true,
                                title: 'traveller.error.auth.title',
                                message: message_error
                            })

                        }
                        else {
                            this.$store.commit(_GlobalHelper.mutations.travellerCredentials, {...data, ...{
                                card_number: event.username,
                                password: event.password
                            }})
                            event.username = null
                            event.password = null
                            this.setAuthenticate({
                                show: false
                            })
                        }

                    })
                    .finally(() => {
                        this.loading_authenticate = false
                    })
                }, 1500)
            }   
        }
    }
</script>

<style lang="scss">
    @import '#/app.scss';

    .red-vp {
        color: rgb(183, 28, 28);
    }
</style>